import 'magnific-popup'
import $ from 'jquery'

class AudienceModal {
  constructor() {
    // $('#uuid-08aecf90-b601-48a4-9e06-013b8ecafd74').magnificPopup()
    // Audience Modal
    if (sessionStorage.getItem('audience') === null) {
      $.magnificPopup.open({
        items: {
          src: '#audience-modal'
        },
        showCloseBtn: false,
        mainClass: 'audience-modal',
        closeOnBgClick: false,
        callbacks: {
          afterClose: function () {
            // console.log('test');
            const event = new CustomEvent('audiencepopupclose')
            document.dispatchEvent(event)
          }
        }
      })
      $('.audience-modal .hcp').on('click', (e) => {
        if (document.location.pathname !== '/for-patients-and-caregivers') {
          e.preventDefault()
          $('#audience-modal').magnificPopup('close')
        }
      })
      $('.audience-modal .patient').on('click', (e) => {
        if (document.location.pathname === '/for-patients-and-caregivers') {
          e.preventDefault()
          $('#audience-modal').magnificPopup('close')
        }
      })
      sessionStorage.setItem('audience', '1')
    }
  }
}
export default AudienceModal


// WEBPACK FOOTER //
// ./js/classes/audience-modal.class.js